export function formatFileSize(size) {
    if (size < 1024) {
        return `${size} B`;
    }
    if (size < 1024 * 1024) {
        return `${Number((size / 1024).toFixed(1))} KB`;
    }
    return `${Number((size / (1024 * 1024)).toFixed(1))} MB`;
}
